
import React from 'react';
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';

const VideoNodeView: React.FC<NodeViewProps> = ({ node }) => {
  const { src, platform, caption } = node.attrs;

  // Generate embed code based on platform and video ID
  const renderEmbed = () => {
    if (!src) {
      return <div className="video-error">Invalid video source</div>;
    }

    if (platform === 'youtube') {
      return (
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${src}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video player"
          aria-label="YouTube video player"
        ></iframe>
      );
    } else if (platform === 'vimeo') {
      return (
        <iframe
          src={`https://player.vimeo.com/video/${src}`}
          width="560"
          height="315"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo video player"
          aria-label="Vimeo video player"
        ></iframe>
      );
    }
    return <div className="video-error">Unsupported video platform</div>;
  };

  return (
    <NodeViewWrapper className="video-embed" data-platform={platform} data-src={src}>
      <div className="video-container">
        {renderEmbed()}
      </div>
      {caption && <p className="video-caption">{caption}</p>}
    </NodeViewWrapper>
  );
};

export default VideoNodeView;
